// extracted by mini-css-extract-plugin
export var notificationHost = "_cd-0";